module.exports = __webpack_public_path__ + "pic/71.a5355fd8.png";